import ServiceDetailLayout from "@/components/site/ServiceDetailLayout";

export default function Salesforce() {
  return (
    <ServiceDetailLayout
      eyebrow="Salesforce & CRM Operations"
      title="Connect marketing automation with the CRM process sales depends on."
      subtitle="Xadentra helps teams align Adobe Marketo Engage and Salesforce so leads move through the funnel with the right data, routing, lifecycle status, and campaign attribution."
      cta="Align Marketing & Sales"
      seo={{
        title: "Salesforce & CRM Operations | Adobe Marketo Engage Salesforce Integration — Xadentra",
        description: "Salesforce CRM consulting, Adobe Marketo Engage↔SFDC sync hardening, lead routing, MQL workflows, lifecycle stages, and campaign attribution.",
        path: "/services/salesforce-crm",
      }}
      sections={[
        {
          heading: "Sync, mapping & data quality",
          items: [
            "Salesforce and Adobe Marketo Engage sync support",
            "Field mapping and data governance",
            "Lead source and UTM capture",
            "Duplicate and data-quality review",
            "Campaign member status strategy",
          ],
        },
        {
          heading: "Lead lifecycle & routing",
          items: [
            "Lead routing logic (account-based, round-robin, queue-aware)",
            "MQL and sales handoff workflows",
            "Lifecycle stage alignment across marketing & sales",
            "Sales alert flows and SLA monitoring",
            "Re-engagement and recycle workflows",
          ],
        },
        {
          heading: "Reporting & sales handoff",
          items: [
            "Operational reporting for marketing & sales",
            "Closed-loop attribution to campaign member",
            "Sales acceptance / rejection feedback loops",
            "Salesforce dashboards for marketing impact",
            "Forecast-ready pipeline reporting",
          ],
        },
      ]}
      related={[
        { to: "/marketo-services", label: "Adobe Marketo Engage Services" },
        { to: "/services/martech-integration", label: "Martech & Data" },
        { to: "/services/reporting-attribution", label: "Reporting & Attribution" },
      ]}
    />
  );
}
